export default __webpack_public_path__ + "static/media/noun-cv-1084868.c2b94c4a.svg";